import { makeButton } from './Button'
import { makePrimaryButton } from './PrimaryButton'
import { makeSecondaryButton } from './SecondaryButton'

export const PrimaryButtonLink = makePrimaryButton(makeButton('a'))

export const SecondaryButtonLink = makeSecondaryButton(makeButton('a'))
